<template>
    <div class="progress-container" :style="{ width: width + 'px', height: ' 36px' }">
        <div class="progress-label"
            :style="{ top: (100 - progress) * height / 100 - 11.5 + 'px', right: (100 - progress) * width / 100 + 3 + 'px' }">
            {{ standardValue }}</div>
        <div class="progress-bar"
            :style="{ width: progress + '%', height: height + 'px', backgroundColor: progressBarColor, top: 11 + 'px' }">
        </div>
    </div>
</template>

<script>
export default {
    props: {
        standardValue: {
            type: String,
            default: ""
        },

        progressValue: {
            type: Number,
            default: 0
        },
        width: {
            type: Number,
            default: 294
        },
        height: {
            type: Number,
            default: 7
        },
        progressBarColor: {
            type: String,
            default: '#C5C5C5'
        }
    },
    data() {
        return {
            progress: 0
        };
    },
    watch: {
        progressValue(newValue) {
            this.progress = newValue;
        }
    },
    mounted() {
        this.progress = this.progressValue;
    }
};
</script>

<style>
.progress-container {
    position: relative;
    border-radius: 4px;
    padding: 4px 0;
    overflow: hidden;
}

.progress-bar {
    border-radius: 4px;
    margin-top: 4px;
    transition: width 0.3s ease-in-out;
    position: relative;
}

.progress-label {
    position: absolute;
    font-size: 13px;
    color: #333;
    font-weight: bold;

}
</style>
